<template>
  <v-container class="pa-0 ma-0">
    <v-card outlined class="pa-4 ma-0" style="height: 413px; background-color: #e3ffed1f">
      <!-- header -->
      <v-container class="chart-header d-flex justify-space-between pa-0 ma-0">
        <v-container class="pa-0 ma-0 d-flex flex-column">
          <v-card-text class="pa-0 ma-0 text-body-1">
            {{ $t("topPayments") }}
          </v-card-text>
          <v-card-text class="pa-0 ma-0 text-body-2">
            {{ $t("topPettyCashExpenses") }}
          </v-card-text>
        </v-container>
      </v-container>
      <!-- bar chart -->
      <apexchart
        v-if="hasData"
        ref="chartComponent"
        type="bar"
        height="337"
        width="100%"
        :options="chartOptions"
        :series="chartSeries"
      />
      <v-container
        v-else
        class="pa-0 ma-0 d-flex flex-column align-center justify-center"
        style="height: 337px"
      >
        <img
          :src="require('@/assets/dashboard/no-data(3).png')"
          max-width="100"
          height="100"
          contain
          class="mb-3"
        />
        <v-card-text class="text-body-2 grey--text text-center">
          {{ $t("nothing-for-render") }}
        </v-card-text>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import ApexCharts from "apexcharts";
import jsPDF from "jspdf";
export default {
  name: "TopProductsChart",
  props: {
    filterChart: {
      type: Object,
      default: null,
    },
    advanceFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      selectedLimit: 10,
      chartApiResponse: {
        products: [],
        values: [],
      },
    };
  },
  computed: {
    hasData() {
      return (
        Array.isArray(this.chartApiResponse?.values) &&
        this.chartApiResponse.values.length > 0 &&
        this.chartApiResponse.values.some((val) => Number(val) > 0)
      );
    },
    productLimitItems() {
      return [
        { text: this.$t("top10Products"), value: 10 },
        { text: this.$t("top20Products"), value: 20 },
      ];
    },
    chartSeries() {
      return [
        {
          name: this.$t("petty"),
          data: this.chartApiResponse.values,
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          type: "bar",
          toolbar: {
            show: false,
          },
          fontFamily: "IRANSans",
          width: "100%",
        },
        plotOptions: { bar: { horizontal: true, barHeight: "60%", borderRadius: 6 } },
        colors: ["#EAB308"],
        dataLabels: { enabled: false },
        xaxis: {
          categories: this.chartApiResponse.products,
          labels: { style: { fontSize: "10px" } },
        },
        yaxis: {
          labels: {
            style: { fontSize: "11px" },
            offsetX: this.$vuetify.rtl ? -70 : 0,
          },
        },
        grid: { borderColor: "#EEEEEE", strokeDashArray: 4 },
        tooltip: {
          rtl: true,
          y: {
            formatter: (val) =>
              `${val.toLocaleString()} ${this.$store.state.currency.name}`,
          },
        },
        legend: { show: false },
      };
    },
  },
  mounted() {
    this.getTopProductData();
  },
  watch: {
    filterChart: {
      deep: true,
      handler(newVal) {
        this.this.getTopProductData();
        newVal;
      },
    },

    advanceFilter: {
      deep: true,
      handler(newVal) {
        this.getTopProductData(newVal);
      },
    },
    selectedLimit() {
      this.getTopProductData();
    },
  },
  methods: {
    async exportChart(format) {
      const chartRef = this.$refs.chartComponent?.chart;
      if (!chartRef) {
        this.$toast?.error?.("چارتی یافت نشد!");
        return;
      }
      const tempChartContainer = document.createElement("div");
      tempChartContainer.style.position = "fixed";
      tempChartContainer.style.visibility = "hidden";
      document.body.appendChild(tempChartContainer);
      const clonedOptions = {
        ...chartRef.w.config,
        chart: {
          type: chartRef.w.config.chart.type,
          animations: { enabled: false },
          toolbar: { show: false },
        },
        xaxis: { ...chartRef.w.config.xaxis },
        yaxis: {
          ...chartRef.w.config.yaxis,
        },
      };
      const tempChart = new ApexCharts(tempChartContainer, clonedOptions);
      await tempChart.render();

      try {
        let exportParams = { width: 1400, height: 900, scale: 4 };
        if (format === "png" || format === "svg") {
          const { imgURI } = await tempChart.dataURI(exportParams);
          this.downloadImage(imgURI, `chart-export.${format}`);
        } else if (format === "pdf") {
          await this.exportToPDF(tempChart, exportParams);
        } else if (format === "excel") {
          await this.exportToExcel();
        }
      } catch (e) {
        this.$toast?.error?.("خطا در خروجی گرفتن!");
      } finally {
        await tempChart.destroy();
        if (tempChartContainer && tempChartContainer.parentNode)
          tempChartContainer.parentNode.removeChild(tempChartContainer);
      }
    },
    async exportToPDF(tempChart, exportParams) {
      try {
        const { imgURI } = await tempChart.dataURI(exportParams);
        const pdf = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
        const pdfWidth = 270;
        const pdfHeight = 160;
        pdf.addImage(imgURI, "PNG", 15, 15, pdfWidth, pdfHeight);
        pdf.setFontSize(14);
        pdf.text("خروجی PDF پرفروش‌ سود تریت محصولات", 15, pdfHeight + 28, {
          align: "right",
        });
        pdf.save("chart-export.pdf");
      } catch (error) {
        this.$toast?.error?.("خطا در ساخت pdf !");
      }
    },
    downloadImage(imgURI, fileName) {
      const a = document.createElement("a");
      a.href = imgURI;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    getTopProductData(filters = {}) {
      const hasDefaultDate = !!filters?.fromDate && !!filters?.toDate;
      const Type = hasDefaultDate ? false : "year";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/top-ten-petty-cost-by-group", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data.data.topTenPettyCostByGroup;
          let bestProduct = res.slice(-app.selectedLimit);
          app.chartApiResponse = {
            products: bestProduct.map((item) =>
              item.account_name?.split(" ").slice(0, 2).join(" ")
            ),
            values: bestProduct.map((item) => item.amount),
          };
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .v-btn:not(.v-btn--round).v-size--small {
  min-width: 30px;
}
::v-deep .v-text-field.v-text-field--outlined fieldset {
  border-color: #d9d9d9;
}
.chart-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
</style>
